<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title> Filtros </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <span>Estatus </span>
              <v-autocomplete
                v-model="form.status"
                :items="allstatus"
                label="Seleccione estatus"
                no-data-text="No hay estatus"
                solo
                dense
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-container>
          <v-row>
            <v-col cols="12" xl="4" lg="4" md="4">
              <v-btn color="gray" dark @click="show = false" block>
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="12" xl="4" lg="4" md="4">
              <v-btn color="info" @click="cleanFilters" block>
                Limpiar filtros
              </v-btn>
            </v-col>
            <v-col cols="12" xl="4" lg="4" md="4">
              <v-btn color="primary" @click="applyFilters" block>
                Aplicar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    form: {
      status: null,
    },
    allstatus: [
      {
        text: "Iniciado",
        value: "STARTED",
      },
      { text: "Pausa", value: "PAUSE" },
      { text: "Programado", value: "PROGRAMMED" },
      { text: "Finalizado", value: "FINISHED" },
      { text: "Cancelado", value: "CANCELED" },
      { text: "Entregado", value: "DELIVERED" },
    ],
  }),
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    cleanFilters() {
      this.form = {
        status: null,
      };
      this.$emit("filter", this.form);
    },
    applyFilters() {
      this.$emit("filter", this.form);
    },
  },
};
</script>
